/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import JumpingDots from 'components/jumping-dots';
import DateTime from 'components/date-time';

const ExportMetaData = ({ exportNewSales, metaData, ...props }) => {
    const [requesting, setRequesting] = useState(false);

    const handleExportNewSales = async () => {
        setRequesting(true);
        try {
            await exportNewSales();
        } catch (error) {}
        setRequesting(false);
    };

    if (!metaData) {
        return null;
    }

    const disabled = requesting;

    return (
        <Box className='table-wrapper'>
            <table>
                <thead>
                    <tr>
                        <th>Last checked for sales</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{(metaData.last_exported_at) ? <DateTime date={metaData.last_exported_at} format='Do MMM, YYYY HH:mm:ss' /> : "-"}</td>
                        <td className='align-right'>
                            <Button disabled={requesting} onClick={handleExportNewSales} compact>
                                {requesting ? <div>Searching <JumpingDots /></div> : 'Search for new sales'}
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Box>
    );
};

export default ExportMetaData;
